// Friendly labels for the SKIPPED_* codes the analysis pipeline writes to
// CallAnalysis.lastError. Used by both CallAnalysisPanel (per-call view)
// and AiJobsSection (admin Recent analyses table).

export const SKIP_LABEL: Record<string, string> = {
  SKIPPED_NO_RECORDING: 'No recording',
  SKIPPED_TOO_SHORT: 'Call too short',
  SKIPPED_DISPOSITION: 'Skipped — no-contact disposition',
  SKIPPED_BUDGET: 'Skipped — daily AI budget reached',
  SKIPPED_EMPTY_TRANSCRIPT: 'Empty transcript',
  SKIPPED_EXCLUDED_NUMBER: 'Excluded number (QA)',
  SKIPPED_BULK_JOB_CANCELLED: 'Bulk job cancelled',
};

export function labelForSkipReason(code: string | null | undefined): string {
  if (!code) return 'Skipped';
  return SKIP_LABEL[code] ?? code;
}
